import z from "zod";
import { CourseIdScheme } from "./ids";
import { CatalogOrigin } from "./enums/CatalogOrigin";

export const CourseDBScheme = z.object({
  id: CourseIdScheme,
  name: z.string(),
  sortOrder: z.number(),
  origin: z.enum(CatalogOrigin).optional(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const RestGetCourse = CourseDBScheme;

export const RestCreateCourse = CourseDBScheme.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});

export const RestUpdateCourse = CourseDBScheme.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
}).partial();

export type DBCourse = z.infer<typeof CourseDBScheme>;
export type RestCourse = z.infer<typeof RestGetCourse>;
export type RestCreateCourse = z.infer<typeof RestCreateCourse>;
export type RestUpdateCourse = z.infer<typeof RestUpdateCourse>;
